



















































































































































































































import {
  Component,
  Emit,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class BirthdaySelect extends Vue {
  @Prop({ default: '年' })
  year!: string;

  @Prop({ default: '月' })
  month!: string;

  @Prop({ default: '日' })
  date!: string;

  y!: string;

  m!: string;

  d!: string;

  @Emit('setYear')
  setYear() {
    return this.y.slice(0, -1);
  }

  @Emit('setMonth')
  setMonth() {
    return this.m.slice(0, -1);
  }

  @Emit('setDate')
  setDate() {
    return this.d.slice(0, -1);
  }

  private get innerYear() {
    return this.y;
  }

  private set innerYear(year) {
    this.y = year;
    this.setYear();
  }

  private get innerMonth() {
    return this.m;
  }

  private set innerMonth(month) {
    this.m = month;
    this.setMonth();
  }

  private get innerDate() {
    return this.d;
  }

  private set innerDate(date) {
    this.d = date;
    this.setDate();
  }
}
